const DEFAULT_ALLOWED_STARTING_DIGITS = ["9", "7"];
const DEFAULT_NATIONAL_NUMBER_LENGTH = 9;

const stripCountryCode = (value) => {
  let digits = value.replace(/\D/g, "");

  if (digits.startsWith("00251")) {
    digits = digits.slice(5);
  } else if (digits.startsWith("251")) {
    digits = digits.slice(3);
  } else if (digits.startsWith("0")) {
    digits = digits.slice(1);
  }

  return digits;
};

const isAllowedStartingDigit = (digit, allowedStartingDigits) => {
  if (!digit) return false;
  if (!Array.isArray(allowedStartingDigits) || allowedStartingDigits.length === 0) {
    return true;
  }
  return allowedStartingDigits.includes(digit);
};

export const normalizeEthiopianPhone = (value, options = {}) => {
  const {
    forcePrefix = false,
    allowedStartingDigits = DEFAULT_ALLOWED_STARTING_DIGITS,
    nationalNumberLength = DEFAULT_NATIONAL_NUMBER_LENGTH,
  } = options;
  const rawValue = value == null ? "" : String(value);

  if (!forcePrefix && rawValue.trim() === "") {
    return "";
  }

  const digits = stripCountryCode(rawValue);

  let filtered = "";
  for (const ch of digits) {
    if (filtered.length === 0) {
      if (isAllowedStartingDigit(ch, allowedStartingDigits)) {
        filtered += ch;
      }
      continue;
    }
    if (filtered.length >= nationalNumberLength) {
      break;
    }
    filtered += ch;
  }

  return `+251${filtered}`;
};

export const isValidEthiopianPhone = (value, options = {}) => {
  const {
    allowedStartingDigits = DEFAULT_ALLOWED_STARTING_DIGITS,
    nationalNumberLength = DEFAULT_NATIONAL_NUMBER_LENGTH,
  } = options;
  if (value == null) return false;
  const rawValue = String(value).trim();
  if (!rawValue) return false;

  const digits = stripCountryCode(rawValue);

  if (digits.length !== nationalNumberLength) return false;
  if (!isAllowedStartingDigit(digits[0], allowedStartingDigits)) return false;
  return true;
};
